export const fullName = (state) => {

    return state.loginUser.last_name + " " + state.loginUser.first_name;

}

